module.exports = __webpack_public_path__ + "img/ARDILLA.f7f9fd46.png";